<template>
	<v-col class="ma-0 pa-0" cols="12" id="head_title">
		<v-col class="pa-0" cols="12" id="main_content_maxwidthset">
			<v-row class="ma-0 pa-0" align="center" id="header_height" justify="space-between">
				<v-col class="ma-0 pa-0" cols="auto">
					<v-row class="ma-0 pa-0" align="center">
						<v-btn width="12rem" height="50px" class="ma-0 pa-0"
							v-if="tokenExisted && isMainRole"
							id="header_btn" elevation="0" @click="goAdminPage"
							:class="{'current_btn': currentRoute == 'adminPage' }">
							{{'X-API-KEY / Role'}}
						</v-btn>
						<v-btn width="13rem" height="50px" class="ma-0 pa-0" 
							v-if="isMainRole"
							id="header_btn" elevation="0" @click="goTestDevicePage"
							:class="{'current_btn': currentRoute == 'testDeviceData' }">
							{{'테스트 디바이스 데이터관리'}}
						</v-btn>
						<v-btn width="13rem" height="50px" class="ma-0 pa-0" 
							id="header_btn" elevation="0" @click="goDeviceChangePage"
							:class="{'current_btn': currentRoute == 'testDeviceChange' }">
							{{'장비교체 테스트'}}
						</v-btn>
						<v-btn width="13rem" height="50px" class="ma-0 pa-0" 
							id="header_btn" elevation="0" @click="goUITestPage"
							:class="{'current_btn': currentRoute == 'testPage' }">
							{{'UI 테스트'}}
						</v-btn>
					</v-row>
				</v-col>
				<v-col class="ma-0 pa-0" cols="auto" align="right">
					<v-row class="ma-0 pa-0 pr-3" align="center" justify="end">
						{{'UMembers 로그인 : '}}
						<v-col class="ma-0 pa-0 ml-3" cols="auto" style="color:green;font-weight:bold;"
							v-if="tokenExisted">{{ tokenExisted }}</v-col>
						<v-col class="ma-0 pa-0 ml-3" cols="auto" style="color:red;font-weight:bold;"
							v-else>{{ tokenExisted }}</v-col>
					</v-row>
				</v-col>
			</v-row>
		</v-col>
	</v-col>
</template>

<script>
import mixin from '@/mixin';
export default {
	components: {
		
	},
	mixins: [mixin.common],
	data: () => ({
		currentRoute: '',
		tokenExisted: false,
	}),
	watch: {
		$route: {
      immediate: true,
      handler(to, from) {
        // console.log(to);
        this.currentRoute = to.name;
      }
    },
	},
	created() {
		this.currentRoute = this.$route.name;
		const token = this.$store.getters.getToken;
		if(token) {
			this.tokenExisted = true;
		} else {
			this.tokenExisted = false;
		}
	},
	methods: {
		goAdminPage() {
			this.pushRoute('/admin', {});
		},
		goTestDevicePage() {
			this.pushRoute('/admin/test-device-data', {});
		},
    goDeviceChangePage() {
      this.pushRoute('/admin/test-device-change', {});
    },
		goUITestPage() {
			this.pushRoute('/test', {});
		}
	}
}
</script>

<style lang="scss" scoped>
#head_title {
	position: sticky;
	top: 0;
	z-index: 5;
}
#header_btn {
	color: #979FB1;
	border-bottom: 1px solid #484848;
	background-color: transparent;
	min-width: 1rem;
}
.current_btn {
	color: white !important;
	background-color: transparent;
	min-width: 1rem;
	border-bottom: 4px solid #008DD0 !important;
}
</style>